import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import withDragAndDrop from 'react-big-calendar/lib/addons/dragAndDrop';
import moment from 'moment';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import 'react-big-calendar/lib/addons/dragAndDrop/styles.css';
import 'moment/locale/tr'; // Türkçe yerelleştirme
import './Patients.css'; // Stil dosyasını en son yükle ki override etsin

moment.locale('tr');
const localizer = momentLocalizer(moment);
const DnDCalendar = withDragAndDrop(Calendar);

// 09:00 - 17:00 arası 30 dakikalık dilimler
const timeSlots = [];
for (let i = 9; i < 17; i++) {
  timeSlots.push(`${i.toString().padStart(2, '0')}:00`);
  timeSlots.push(`${i.toString().padStart(2, '0')}:30`);
}

function Appointments({ user }) {
  const [view, setView] = useState('list'); // 'list' veya 'calendar'
  const [appointments, setAppointments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [patientsList, setPatientsList] = useState([]);
  const [treatmentsList, setTreatmentsList] = useState([]); // Tedavi listesi
  const [doctorsList, setDoctorsList] = useState([]); // Doktor listesi
  const [filterType, setFilterType] = useState('all'); // Filtreleme state'i
  const [treatmentFilter, setTreatmentFilter] = useState(''); // Tedavi filtresi
  const [searchTerm, setSearchTerm] = useState(""); // Arama filtresi
  const [showOnlyMyApps, setShowOnlyMyApps] = useState(false); // Sadece benim randevularım filtresi
  const [sortConfig, setSortConfig] = useState({ key: 'appointment_date', direction: 'desc' }); // Sıralama state'i
  const [newAppointment, setNewAppointment] = useState({
    patient_id: '',
    treatment_id: '', // Tedavi ID
    appointment_date: '',
    description: '',
    price: '', // Fiyat alanı
    parent_name: '', // Ebeveyn adı
    doctor_id: '' // Doktor seçimi
  });
  const [isEditing, setIsEditing] = useState(false);
  const [currentId, setCurrentId] = useState(null);
  const [selectedPatientPhone, setSelectedPatientPhone] = useState(''); // Otomatik telefon için
  const [selectedPatientAge, setSelectedPatientAge] = useState(null); // Hasta yaşı için
  const [patientHistory, setPatientHistory] = useState([]); // Hasta geçmişi için
  const [showDetailModal, setShowDetailModal] = useState(false);
  const [selectedAppointment, setSelectedAppointment] = useState(null);
  const [expandedRowId, setExpandedRowId] = useState(null);
  const [patientTab, setPatientTab] = useState('upcoming');

  useEffect(() => {
    // Hasta ise patient_id'yi otomatik set et
    if (user.role === 'patient') {
      setNewAppointment(prev => ({ ...prev, patient_id: user.id }));
      setView('list'); // Hastalar her zaman liste görünümünde başlasın
    } else {
      // Admin/Doktor ise varsayılan ayarlara dönülebilir veya olduğu gibi bırakılır
      // Ancak hasta değilse patientTab state'i etkisizdir, bu güvenlidir.
    }

    fetchAppointments();
    // Hastaları çek (Dropdown için) - Sadece yetkili kullanıcılar
    if (user.role !== 'patient') {
      axios.get('./backend/get_patients.php')
        .then(res => {
          if (Array.isArray(res.data)) setPatientsList(res.data);
        })
        .catch(err => console.error(err));
    }

    // Tedavileri çek
    axios.get('./backend/get_treatments.php')
      .then(res => {
        if (Array.isArray(res.data)) setTreatmentsList(res.data);
      })
      .catch(err => console.error(err));

    // Doktorları çek (Admin ve Doktorlar)
    axios.get('./backend/get_users.php')
      .then(res => {
        if (Array.isArray(res.data)) {
            setDoctorsList(res.data.filter(u => u.role === 'doctor' || u.role === 'admin'));
        }
      })
      .catch(err => console.error(err));
  }, []);

  const fetchAppointments = () => {
    setLoading(true);
    
    let url = `./backend/get_appointments.php?role=${user.role}`;
    if (user.role === 'patient') {
        url += `&user_id=${user.id}`;
    }

    axios.get(url)
      .then(response => {
        if (Array.isArray(response.data)) {
          setAppointments(response.data);
        } else {
          console.error("Beklenmeyen veri formatı:", response.data);
          setAppointments([]);
        }
        setLoading(false);
      })
      .catch(err => {
        console.error('Hata:', err);
        setError('Veriler yüklenirken bir hata oluştu.');
        setLoading(false);
      });
  };

  const calculateAge = (birthDateString) => {
    if (!birthDateString) return null;
    const birthDate = new Date(birthDateString);
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    // Hafta sonu kontrolü (Cumartesi=6, Pazar=0)
    if (name === 'appointment_date' && value) {
      const date = new Date(value);
      const day = date.getDay();
      if (day === 0 || day === 6) {
        toast.error('Hafta sonları (Cumartesi-Pazar) randevu oluşturulamaz. Lütfen hafta içi bir tarih seçiniz.');
        return;
      }
    }

    // Hasta seçildiğinde telefon numarasını bul ve getir
    if (name === 'patient_id') {
      const patient = patientsList.find(p => p.id.toString() === value.toString());
      setSelectedPatientPhone(patient ? patient.phone : '');
      setSelectedPatientAge(patient ? calculateAge(patient.birth_date) : null);

      // Hasta seçildiğinde geçmiş randevularını çek
      if (value) {
        axios.get(`./backend/get_appointments.php?role=patient&user_id=${value}`)
          .then(res => setPatientHistory(Array.isArray(res.data) ? res.data : []))
          .catch(err => console.error(err));
      } else {
        setPatientHistory([]);
      }
    }

    // Tedavi seçildiğinde fiyatı otomatik getir
    if (name === 'treatment_id') {
      const treatment = treatmentsList.find(t => t.id.toString() === value.toString());
      setNewAppointment(prev => ({
        ...prev,
        [name]: value,
        price: treatment ? treatment.price : ''
      }));
      return; // setNewAppointment'ı yukarıda çağırdığımız için burada return ediyoruz
    }

    setNewAppointment({ ...newAppointment, [name]: value });
  };

  // Seçilen güne ait doktor randevularını filtrele
  const getDailySchedule = () => {
    if (!newAppointment.appointment_date) return [];
    const selectedDateStr = newAppointment.appointment_date.split('T')[0];
    return appointments.filter(app => app.appointment_date.startsWith(selectedDateStr) && app.status !== 'cancelled')
      .sort((a, b) => new Date(a.appointment_date) - new Date(b.appointment_date));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (isEditing) {
      // GÜNCELLEME
      const data = { ...newAppointment, id: currentId };
      axios.post('./backend/update_appointment_full.php', data)
        .then(response => {
          toast.success(response.data.message);
          setShowModal(false);
          setIsEditing(false);
          setNewAppointment({ patient_id: user.role === 'patient' ? user.id : '', treatment_id: '', appointment_date: '', description: '', price: '', parent_name: '', doctor_id: '' });
          setSelectedPatientAge(null);
          fetchAppointments();
        })
        .catch(error => {
          toast.error(error.response?.data?.message || 'Güncelleme başarısız.');
        });
    } else {
      // YENİ EKLEME
      const defaultDoctorId = (user.role === 'admin' || user.role === 'doctor') ? user.id : '';
      const data = { ...newAppointment, doctor_id: newAppointment.doctor_id || defaultDoctorId };
      axios.post('./backend/book_appointment.php', data)
        .then(response => {
          toast.success(response.data.message);
          setShowModal(false);
          setNewAppointment({ patient_id: user.role === 'patient' ? user.id : '', treatment_id: '', appointment_date: '', description: '', price: '', parent_name: '', doctor_id: '' });
          setSelectedPatientAge(null);
          fetchAppointments();
        })
        .catch(error => {
          toast.error(error.response?.data?.message || 'Randevu oluşturulamadı.');
        });
    }
  };

  // Durum Güncelleme Fonksiyonu
  const handleStatusChange = (id, newStatus, e) => {
    // GÜVENLİK KONTROLÜ: Hastalar durum değiştiremez
    if (user.role === 'patient') {
        return; 
    }

    if (e) e.stopPropagation(); // Satır tıklamasını engelle
    if (window.confirm(`Randevu durumunu "${newStatus === 'completed' ? 'Tamamlandı' : 'İptal'}" olarak değiştirmek istediğinize emin misiniz?`)) {
      axios.post('./backend/update_appointment_status.php', { id, status: newStatus })
        .then(response => {
          toast.success(response.data.message);
          setShowDetailModal(false); // Detay modalı açıksa kapat
          fetchAppointments(); // Listeyi yenile
        })
        .catch(error => {
          console.error('Hata:', error);
          toast.error('Durum güncellenemedi.');
        });
    }
  };

  // Durum Metni Çevirisi
  const getStatusText = (status) => {
    switch (status) {
      case 'scheduled': return 'Planlandı';
      case 'completed': return 'Tamamlandı';
      case 'cancelled': return 'İptal Edildi';
      default: return status;
    }
  };

  // Sıralama Fonksiyonu
  const handleSort = (key) => {
    let direction = 'asc';
    if (sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    setSortConfig({ key, direction });
  };

  // Filtreleme ve Sıralama Mantığı
  const filteredAppointments = appointments.filter(app => {
    // Doktor filtresi
    if (showOnlyMyApps && user && String(app.doctor_id) !== String(user.id)) {
      return false;
    }

    // Arama filtresi (Hasta veya Doktor adı)
    if (searchTerm && !app.patient_name?.toLowerCase().includes(searchTerm.toLowerCase()) && !app.doctor_name?.toLowerCase().includes(searchTerm.toLowerCase())) {
      return false;
    }

    // Tedavi filtresi
    if (treatmentFilter && String(app.treatment_id) !== String(treatmentFilter)) {
      return false;
    }

    const appDate = new Date(app.appointment_date);

    if (user.role === 'patient') {
        const now = new Date();
        if (patientTab === 'upcoming') {
            return appDate >= now;
        } else {
            return appDate < now;
        }
    }

    if (filterType === 'all') return true;
    const today = new Date();

    if (filterType === 'today') {
      return appDate.toDateString() === today.toDateString();
    }
    if (filterType === 'week') {
      const startOfWeek = new Date(today);
      startOfWeek.setDate(today.getDate() - today.getDay()); // Pazar
      startOfWeek.setHours(0, 0, 0, 0);

      const endOfWeek = new Date(startOfWeek);
      endOfWeek.setDate(startOfWeek.getDate() + 6); // Cumartesi
      endOfWeek.setHours(23, 59, 59, 999);

      return appDate >= startOfWeek && appDate <= endOfWeek;
    }
    if (filterType === 'month') {
      return appDate.getMonth() === today.getMonth() && appDate.getFullYear() === today.getFullYear();
    }
    return true;
  }).sort((a, b) => {
    let aValue = a[sortConfig.key];
    let bValue = b[sortConfig.key];

    if (user.role === 'patient') {
        const dateA = new Date(a.appointment_date);
        const dateB = new Date(b.appointment_date);
        return patientTab === 'upcoming' ? dateA - dateB : dateB - dateA;
    }

    // Null kontrolü
    if (aValue === null) aValue = "";
    if (bValue === null) bValue = "";

    // Sayısal karşılaştırma (ID gibi)
    if (!isNaN(aValue) && !isNaN(bValue) && aValue !== "" && bValue !== "") {
      return sortConfig.direction === 'asc' ? aValue - bValue : bValue - aValue;
    }

    // String karşılaştırma
    aValue = aValue.toString().toLowerCase();
    bValue = bValue.toString().toLowerCase();

    if (aValue < bValue) {
      return sortConfig.direction === 'asc' ? -1 : 1;
    }
    if (aValue > bValue) {
      return sortConfig.direction === 'asc' ? 1 : -1;
    }
    return 0;
  });

  // Excel/CSV Dışa Aktarma Fonksiyonu
  const handleExport = () => {
    // Türkçe karakter sorunu olmaması için BOM (Byte Order Mark) ekliyoruz
    const BOM = "\uFEFF";
    const headers = ["ID", "Hasta Adı", "Doktor Adı", "Tarih", "Tedavi", "Açıklama", "Durum"];

    const csvContent = headers.join(";") + "\n" + filteredAppointments.map(app => {
      return [
        app.id,
        `"${app.patient_name}"`,
        `"${app.doctor_name}"`,
        `"${new Date(app.appointment_date).toLocaleString()}"`,
        `"${app.treatment_name || '-'}"`,
        `"${(app.description || '').replace(/"/g, '""')}"`, // Açıklamadaki tırnakları temizle
        getStatusText(app.status)
      ].join(";");
    }).join("\n");

    const blob = new Blob([BOM + csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "randevu_listesi.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  // Silme İşlemi
  const handleDelete = (id) => {
    if (window.confirm("Bu randevuyu silmek istediğinize emin misiniz?")) {
      axios.post('./backend/delete_appointment.php', { id })
        .then(res => {
          toast.success(res.data.message);
          fetchAppointments();
        });
    }
  };

  // Düzenleme Modunu Aç
  const handleEdit = (app) => {
    setNewAppointment({
      patient_id: app.patient_id,
      appointment_date: app.appointment_date.replace(' ', 'T').substring(0, 16), // YYYY-MM-DDTHH:mm formatı
      description: app.description || '',
      treatment_id: app.treatment_id || '',
      price: app.price || '', // Kayıtlı fiyat varsa getir
      parent_name: app.parent_name || '',
      doctor_id: app.doctor_id || ''
    });
    setSelectedPatientPhone(app.patient_phone || ''); // Düzenlerken telefonu getir
    
    const patient = patientsList.find(p => p.id.toString() === app.patient_id.toString());
    setSelectedPatientAge(patient ? calculateAge(patient.birth_date) : null);

    setCurrentId(app.id);
    setIsEditing(true);
    setShowModal(true);
  };

  const handleRowClick = (appointment) => {
    setSelectedAppointment(appointment);
    setShowDetailModal(true);
  };

  const toggleRow = (id) => {
    if (window.innerWidth <= 768) {
      setExpandedRowId(expandedRowId === id ? null : id);
    } else {
      // Desktop behavior
    }
  };

  // Takvim Etkinliklerini Hazırla
  const calendarEvents = filteredAppointments.map(app => ({
    id: app.id,
    title: `${app.patient_name} - ${app.doctor_name}`,
    tooltip: `Hasta: ${app.patient_name}\nTel: ${app.patient_phone || '-'}\nDoktor: ${app.doctor_name}\nTedavi: ${app.treatment_name || '-'}\nDurum: ${getStatusText(app.status)}${app.medical_history ? `\n\n⚠ ANAMNEZ: ${app.medical_history}` : ''}`,
    start: new Date(app.appointment_date),
    end: new Date(new Date(app.appointment_date).getTime() + 60 * 60 * 1000), // Varsayılan 1 saat
    resource: app
  }));

  // Seçilen tedaviyi bul (Fiyat gösterimi için)
  const selectedTreatment = treatmentsList.find(t => t.id.toString() === newAppointment.treatment_id.toString());

  // Sürükle Bırak ile Taşıma
  const moveEvent = ({ event, start, end }) => {
    // GÜVENLİK KONTROLÜ: Hastalar randevu taşıyamaz
    if (user.role === 'patient') {
        return;
    }

    const now = new Date();
    if (start < now) {
        toast.error("Geçmiş bir tarihe randevu taşıyamazsınız.");
        return;
    }

    const newDate = moment(start).format('YYYY-MM-DD HH:mm:ss');
    axios.post('./backend/move_appointment.php', { id: event.id, appointment_date: newDate })
      .then(res => {
        toast.success(res.data.message);
        fetchAppointments();
      })
      .catch(err => {
        toast.error(err.response?.data?.message || "Taşıma başarısız");
      });
  };

  if (loading) return <div>Yükleniyor...</div>;
  if (error) return <div>Hata: {error}</div>;

  return (
    <div className="patients-container">
      <div className="header-actions" style={{ flexDirection: user.role === 'patient' ? 'row' : 'column', alignItems: 'stretch' }}>
        {user.role === 'patient' ? (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '15px', width: '100%' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
               <h2>Randevularım</h2>
               <button className="add-btn" onClick={() => { setIsEditing(false); setNewAppointment({ patient_id: user.id, treatment_id: '', appointment_date: '', description: '', doctor_id: '' }); setSelectedPatientAge(null); setShowModal(true); }}>+ Yeni Randevu</button>
            </div>
            <div style={{ display: 'flex', gap: '10px' }}>
                <button onClick={() => setPatientTab('upcoming')} style={{ padding: '10px 20px', borderRadius: '20px', border: 'none', background: patientTab === 'upcoming' ? '#4e73df' : '#e0e0e0', color: patientTab === 'upcoming' ? 'white' : '#555', cursor: 'pointer', fontWeight: 'bold', transition: 'all 0.2s' }}>
                    Yaklaşan Randevular
                </button>
                <button onClick={() => setPatientTab('past')} style={{ padding: '10px 20px', borderRadius: '20px', border: 'none', background: patientTab === 'past' ? '#858796' : '#e0e0e0', color: patientTab === 'past' ? 'white' : '#555', cursor: 'pointer', fontWeight: 'bold', transition: 'all 0.2s' }}>
                    Geçmiş Randevular
                </button>
            </div>
          </div>
        ) : (
        <>
        <div style={{ display: 'flex', alignItems: 'center', gap: '20px', flexWrap: 'wrap', marginBottom: '15px' }}>
          <h2>Randevu Listesi</h2>
          <input
            type="text"
            placeholder="Hasta veya Doktor Ara..."
            className="search-input"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          {user.role !== 'patient' && (
            <label style={{ display: 'flex', alignItems: 'center', gap: '5px', cursor: 'pointer', fontSize: '0.9rem', fontWeight: '600', color: '#5a5c69' }}>
              <input
                type="checkbox"
                checked={showOnlyMyApps}
                onChange={(e) => setShowOnlyMyApps(e.target.checked)}
              />
              Sadece Benim Randevularım
            </label>
          )}
          <select
            value={treatmentFilter}
            onChange={(e) => setTreatmentFilter(e.target.value)}
            style={{ padding: '8px 12px', borderRadius: '20px', border: '2px solid #eaecf4', outline: 'none', cursor: 'pointer', maxWidth: '150px' }}
          >
            <option value="">Tüm Tedaviler</option>
            {treatmentsList.map(t => <option key={t.id} value={t.id}>{t.name}</option>)}
          </select>
          <select
            value={filterType}
            onChange={(e) => setFilterType(e.target.value)}
            style={{ padding: '8px 12px', borderRadius: '20px', border: '2px solid #eaecf4', outline: 'none', cursor: 'pointer' }}
          >
            <option value="all">Tüm Zamanlar</option>
            <option value="today">Bugün</option>
            <option value="week">Bu Hafta</option>
            <option value="month">Bu Ay</option>
          </select>
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '10px' }}>
          {/* Görünüm Değiştirme Butonları */}
          <div style={{ display: 'flex', background: '#fff', padding: '4px', borderRadius: '50px', border: '1px solid #eaecf4', marginRight: '10px' }}>
            <button
              onClick={() => setView('list')}
              style={{
                padding: '8px 20px',
                border: 'none',
                borderRadius: '50px',
                background: view === 'list' ? '#4e73df' : 'transparent',
                color: view === 'list' ? 'white' : '#858796',
                cursor: 'pointer',
                fontWeight: '600',
                transition: 'all 0.2s'
              }}
            >
              Liste
            </button>
            <button
              onClick={() => setView('calendar')}
              style={{
                padding: '8px 20px',
                border: 'none',
                borderRadius: '50px',
                background: view === 'calendar' ? '#4e73df' : 'transparent',
                color: view === 'calendar' ? 'white' : '#858796',
                cursor: 'pointer',
                fontWeight: '600',
                transition: 'all 0.2s'
              }}
            >
              Takvim
            </button>
          </div>

          <div style={{ display: 'flex', gap: '10px' }}>
            <button className="add-btn" onClick={handleExport} style={{ background: 'linear-gradient(135deg, #f6c23e 0%, #dda20a 100%)', boxShadow: '0 4px 15px rgba(246, 194, 62, 0.4)' }}>Excel'e Aktar</button>
            <button className="add-btn" onClick={() => { setIsEditing(false); setNewAppointment({ patient_id: user.role === 'patient' ? user.id : '', treatment_id: '', appointment_date: '', description: '', doctor_id: (user.role === 'admin' || user.role === 'doctor') ? user.id : '' }); setSelectedPatientAge(null); setShowModal(true); }}>+ Yeni Randevu</button>
          </div>
        </div>
        </>
        )}
      </div>

      {view === 'list' ? (
      <table className="data-table accordion-table">
        <thead>
          <tr>
            <th onClick={() => handleSort('id')} className="sortable-header">ID {sortConfig.key === 'id' && (sortConfig.direction === 'asc' ? '▲' : '▼')}</th>
            <th onClick={() => handleSort('patient_name')} className="sortable-header">Hasta Adı {sortConfig.key === 'patient_name' && (sortConfig.direction === 'asc' ? '▲' : '▼')}</th>
            <th onClick={() => handleSort('doctor_name')} className="sortable-header">Doktor Adı {sortConfig.key === 'doctor_name' && (sortConfig.direction === 'asc' ? '▲' : '▼')}</th>
            <th onClick={() => handleSort('appointment_date')} className="sortable-header">Tarih {sortConfig.key === 'appointment_date' && (sortConfig.direction === 'asc' ? '▲' : '▼')}</th>
            <th>Tedavi</th>
            <th>Açıklama</th>
            <th onClick={() => handleSort('status')} className="sortable-header">Durum {sortConfig.key === 'status' && (sortConfig.direction === 'asc' ? '▲' : '▼')}</th>
            <th>İşlemler</th>
          </tr>
        </thead>
        <tbody>
          {filteredAppointments.length > 0 ? (
            filteredAppointments.map(app => (
              <tr key={app.id} onClick={() => window.innerWidth <= 768 ? toggleRow(app.id) : handleRowClick(app)} className={`clickable-row ${expandedRowId === app.id ? 'expanded' : ''}`}>
                <td data-label="ID">{app.id}</td>
                <td data-label="Hasta Adı" className="mobile-visible">{app.patient_name}</td>
                <td data-label="Doktor Adı">{app.doctor_name}</td>
                <td data-label="Tarih" className="mobile-visible">{new Date(app.appointment_date).toLocaleString()}</td>
                <td data-label="Tedavi">{app.treatment_name || '-'}</td>
                <td data-label="Açıklama">{app.description}</td>
                <td data-label="Durum" className="mobile-visible">
                  <span className={`status-badge status-${app.status}`}>
                    {getStatusText(app.status)}
                  </span>
                </td>
                <td data-label="İşlemler">
                  <div className="action-buttons">
                    <button className="edit-btn" style={{ background: '#4e73df', marginRight: '5px' }} onClick={(e) => { e.stopPropagation(); handleRowClick(app); }}>Detay</button>
                  {app.status === 'scheduled' && user.role !== 'patient' && (
                    <>
                      <button
                        className="edit-btn"
                        style={{ background: '#1cc88a', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', padding: '6px 10px' }}
                        onClick={(e) => handleStatusChange(app.id, 'completed', e)}
                        title="Tamamlandı olarak işaretle"
                      >
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>
                      </button>
                      <button
                        className="delete-btn"
                        style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', padding: '6px 10px' }}
                        onClick={(e) => handleStatusChange(app.id, 'cancelled', e)}
                        title="İptal et"
                      >
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
                      </button>
                    </>
                  )}
                  </div>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="8" style={{ textAlign: 'center' }}>
                {filterType !== 'all' ? 'Seçilen tarihte randevu bulunamadı.' : 'Randevu bulunamadı.'}
              </td>
            </tr>
          )}
        </tbody>
      </table>
      ) : (
        <div style={{ height: '600px', background: 'white', padding: '10px', borderRadius: '15px', boxShadow: '0 5px 20px rgba(0,0,0,0.05)', overflowX: 'auto' }}>
          <DnDCalendar
            localizer={localizer}
            events={calendarEvents}
            tooltipAccessor="tooltip"
            startAccessor="start"
            endAccessor="end"
            style={{ height: '100%' }}
            messages={{
              next: "İleri",
              previous: "Geri",
              today: "Bugün",
              month: "Ay",
              week: "Hafta",
              day: "Gün",
              agenda: "Ajanda",
              date: "Tarih",
              time: "Saat",
              event: "Randevu",
              noEventsInRange: "Bu aralıkta randevu yok."
            }}
            onSelectEvent={(event) => handleRowClick(event.resource)}
            onEventDrop={moveEvent}
            draggableAccessor={() => user.role !== 'patient'}
            eventPropGetter={(event) => {
              // CSS sınıflarını duruma göre ata
              return { className: `event-${event.resource.status}` };
            }}
          />
        </div>
      )}

      {showModal && (
        <div className="modal-overlay">
          <div className="modal">
            <div className="modal-header">
              <h3>{isEditing ? 'Randevuyu Düzenle' : 'Yeni Randevu Oluştur'}</h3>
              <button className="close-modal-btn" onClick={() => setShowModal(false)}>
                <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L12.59 14L14 12.59L8.41 7L14 1.41Z" fill="white" />
                </svg>
              </button>
            </div>
            <div className="modal-body">
              <form onSubmit={handleSubmit} id="appointmentForm">
                <div className="form-group">
                  {user.role === 'patient' ? (
                    <>
                      <label>Hasta</label>
                      <input type="text" value={user.full_name} disabled style={{ width: '100%', padding: '12px', borderRadius: '10px', border: '2px solid #eaecf4', backgroundColor: '#f8f9fc' }} />
                    </>
                  ) : (
                    <>
                      <label>Hasta Seçiniz</label>
                      <select name="patient_id" value={newAppointment.patient_id} onChange={handleInputChange} required style={{ width: '100%', padding: '12px', borderRadius: '10px', border: '2px solid #eaecf4' }}>
                        <option value="">Seçiniz...</option>
                        {patientsList.map(p => (
                          <option key={p.id} value={p.id}>{p.full_name}</option>
                        ))}
                      </select>
                      {selectedPatientAge !== null && (
                        <div style={{ marginTop: '5px', fontSize: '0.85rem', color: '#1cc88a', fontWeight: 'bold' }}>
                          🎂 Hasta Yaşı: {selectedPatientAge}
                        </div>
                      )}
                    </>
                  )}
                </div>
                <div className="form-group">
                  <label>Doktor Seçiniz</label>
                  <select name="doctor_id" value={newAppointment.doctor_id} onChange={handleInputChange} required style={{ width: '100%', padding: '12px', borderRadius: '10px', border: '2px solid #eaecf4' }}>
                    <option value="">Seçiniz...</option>
                    {doctorsList.map(d => (
                      <option key={d.id} value={d.id}>{d.full_name} ({d.role === 'admin' ? 'Yönetici' : 'Doktor'})</option>
                    ))}
                  </select>
                </div>
                {user.role !== 'patient' && selectedPatientAge !== null && selectedPatientAge < 18 && (
                  <div className="form-group">
                    <label>Ebeveyn Adı Soyadı <span style={{color: 'red'}}>*</span></label>
                    <input type="text" name="parent_name" value={newAppointment.parent_name} onChange={handleInputChange} required placeholder="18 yaş altı için zorunludur" style={{border: '2px solid #e74a3b'}} />
                  </div>
                )}
                <div className="form-group">
                  <label>Uygulanacak Tedavi {user.role === 'patient' && '(Opsiyonel)'}</label>
                  <select name="treatment_id" value={newAppointment.treatment_id} onChange={handleInputChange} style={{ width: '100%', padding: '12px', borderRadius: '10px', border: '2px solid #eaecf4' }}>
                    <option value="">Seçiniz (Opsiyonel)...</option>
                    {treatmentsList.map(t => (
                      <option key={t.id} value={t.id}>{t.name} ({parseFloat(t.price).toLocaleString('tr-TR')} ₺)</option>
                    ))}
                  </select>
                </div>
                {user.role !== 'patient' && (
                    <div className="form-group">
                      <label>Ücret (TL)</label>
                      <input type="number" name="price" value={newAppointment.price} onChange={handleInputChange} placeholder="Tedavi seçince otomatik gelir, değiştirebilirsiniz" step="0.01" />
                      <small style={{color: '#858796', fontSize: '0.8rem'}}>* Tedavi seçildiğinde otomatik dolar, manuel indirim yapabilirsiniz.</small>
                    </div>
                )}
                <div className="form-group">
                  <label>Hasta Telefonu</label>
                  <input type="text" value={selectedPatientPhone} readOnly disabled style={{ backgroundColor: '#f8f9fc', color: '#858796' }} placeholder="Otomatik gelir..." />
                </div>
                <div className="form-group">
                  <label>Tarih ve Saat</label>
                  <div style={{ display: 'flex', gap: '10px' }}>
                    <input 
                      type="date" 
                      className="form-control"
                      value={newAppointment.appointment_date ? newAppointment.appointment_date.split('T')[0] : ''} 
                      onChange={(e) => {
                        const date = e.target.value;
                        const day = new Date(date).getDay();
                        if (day === 0 || day === 6) {
                          toast.error('Hafta sonları randevu alınamaz.');
                          return;
                        }
                        const currentTime = newAppointment.appointment_date ? newAppointment.appointment_date.split('T')[1] : '09:00';
                        setNewAppointment({ ...newAppointment, appointment_date: `${date}T${currentTime}` });
                      }} 
                      required 
                      style={{ flex: 1, padding: '12px', borderRadius: '10px', border: '2px solid #eaecf4' }}
                    />
                    <select 
                      value={newAppointment.appointment_date ? newAppointment.appointment_date.split('T')[1].substring(0, 5) : '09:00'}
                      onChange={(e) => {
                        const time = e.target.value;
                        const currentDate = newAppointment.appointment_date ? newAppointment.appointment_date.split('T')[0] : new Date().toISOString().split('T')[0];
                        setNewAppointment({ ...newAppointment, appointment_date: `${currentDate}T${time}` });
                      }}
                      style={{ width: '120px', padding: '12px', borderRadius: '10px', border: '2px solid #eaecf4' }}
                    >
                      {timeSlots.map(time => (
                        <option key={time} value={time}>{time}</option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="form-group">
                  <label>Açıklama</label>
                  <input type="text" name="description" value={newAppointment.description} onChange={handleInputChange} placeholder="Not ekleyin..." />
                </div>

                {/* Doktorun O Günkü Programı */}
                {newAppointment.appointment_date && user.role !== 'patient' && (
                  <div style={{ marginTop: '15px', background: '#fff3cd', padding: '10px', borderRadius: '8px', border: '1px solid #ffeeba' }}>
                    <h5 style={{ margin: '0 0 10px 0', color: '#856404' }}>📅 Doktorun O Günkü Diğer Randevuları</h5>
                    {getDailySchedule().length > 0 ? (
                      <ul style={{ listStyle: 'none', padding: 0, margin: 0, fontSize: '0.8rem', color: '#856404' }}>
                        {getDailySchedule().map(app => (
                          <li key={app.id} style={{ marginBottom: '4px' }}>
                            <strong>{new Date(app.appointment_date).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}</strong> - {app.patient_name}
                          </li>
                        ))}
                      </ul>
                    ) : <span style={{ fontSize: '0.8rem', color: '#856404' }}>Bu tarihte başka randevu yok.</span>}
                  </div>
                )}

                {/* Hasta Geçmişi Bölümü */}
                {newAppointment.patient_id && (
                  <div style={{ marginTop: '20px', borderTop: '1px solid #eee', paddingTop: '15px' }}>
                    <h4 style={{ color: '#4e73df', marginBottom: '10px' }}>Hastanın Son Randevuları</h4>
                    {patientHistory.length > 0 ? (
                      <ul style={{ listStyle: 'none', padding: 0, fontSize: '0.85rem', color: '#5a5c69' }}>
                        {patientHistory.slice(0, 3).map(h => (
                          <li key={h.id} style={{ marginBottom: '5px', padding: '5px', background: '#f8f9fc', borderRadius: '5px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <span><strong>{new Date(h.appointment_date).toLocaleDateString()}</strong> - {getStatusText(h.status)}</span>
                            {(h.price || h.treatment_price) && (
                              <span style={{ color: '#1cc88a', fontWeight: 'bold', fontSize: '0.9em' }}>
                                {parseFloat(h.price || h.treatment_price).toLocaleString('tr-TR', { minimumFractionDigits: 2 })} ₺
                              </span>
                            )}
                          </li>
                        ))}
                      </ul>
                    ) : (
                      <p style={{ fontSize: '0.85rem', color: '#858796' }}>Geçmiş randevu bulunamadı.</p>
                    )}
                  </div>
                )}
              </form>
            </div>
            <div className="modal-actions">
              <button type="button" onClick={() => setShowModal(false)} className="cancel-btn">İptal</button>
              <button type="submit" form="appointmentForm" className="save-btn">{isEditing ? 'Güncelle' : 'Oluştur'}</button>
            </div>
          </div>
        </div>
      )}

      {showDetailModal && selectedAppointment && (
        <div className="modal-overlay" onClick={() => setShowDetailModal(false)}>
          <div className="modal" onClick={e => e.stopPropagation()}>
            <div className="modal-header">
              <h3>Randevu Detayları</h3>
              <button className="close-modal-btn" onClick={() => setShowDetailModal(false)}>
                <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L12.59 14L14 12.59L8.41 7L14 1.41Z" fill="white" />
                </svg>
              </button>
            </div>
            <div className="modal-body">
              <div className="detail-content">
                <div className="detail-row"><span className="detail-label">ID:</span> <span className="detail-value">{selectedAppointment.id}</span></div>
                <div className="detail-row"><span className="detail-label">Hasta:</span> <span className="detail-value">{selectedAppointment.patient_name}</span></div>
                {selectedAppointment.parent_name && <div className="detail-row"><span className="detail-label">Ebeveyn:</span> <span className="detail-value">{selectedAppointment.parent_name}</span></div>}
                <div className="detail-row"><span className="detail-label">Doktor:</span> <span className="detail-value">{selectedAppointment.doctor_name}</span></div>
                <div className="detail-row"><span className="detail-label">Tarih:</span> <span className="detail-value">{new Date(selectedAppointment.appointment_date).toLocaleString()}</span></div>
                <div className="detail-row"><span className="detail-label">Tedavi:</span> <span className="detail-value">{selectedAppointment.treatment_name || '-'}</span></div>
                {(selectedAppointment.price || selectedAppointment.treatment_price) && (
                  <div className="detail-row">
                    <span className="detail-label">Ücret:</span>
                    <span className="detail-value">
                      {(() => {
                        const manualPrice = selectedAppointment.price ? parseFloat(selectedAppointment.price) : null;
                        const listPrice = selectedAppointment.treatment_price ? parseFloat(selectedAppointment.treatment_price) : null;
                        
                        if (manualPrice !== null && listPrice !== null && manualPrice < listPrice) {
                          return (
                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
                              <span style={{ textDecoration: 'line-through', color: '#858796', fontSize: '0.9em' }}>{listPrice.toLocaleString('tr-TR', { minimumFractionDigits: 2 })} ₺</span>
                              <span style={{ fontWeight: 'bold', color: '#1cc88a', fontSize: '1.1em' }}>{manualPrice.toLocaleString('tr-TR', { minimumFractionDigits: 2 })} ₺</span>
                              <span style={{ fontSize: '0.75em', color: '#e74a3b', backgroundColor: '#ffe5e5', padding: '2px 6px', borderRadius: '4px', fontWeight: '600', display: 'inline-flex', alignItems: 'center' }}>
                                <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" style={{marginRight:2}}><polyline points="6 9 12 15 18 9"></polyline></svg>
                                {(listPrice - manualPrice).toLocaleString('tr-TR', { minimumFractionDigits: 2 })} ₺ İndirim
                              </span>
                            </div>
                          );
                        }
                        return <span style={{fontWeight: 'bold', color: '#1cc88a'}}>{parseFloat(selectedAppointment.price || selectedAppointment.treatment_price).toLocaleString('tr-TR', { minimumFractionDigits: 2 })} ₺</span>;
                      })()}
                    </span>
                  </div>
                )}
                <div className="detail-row"><span className="detail-label">Açıklama:</span> <span className="detail-value">{selectedAppointment.description}</span></div>
                <div className="detail-row"><span className="detail-label">Durum:</span> <span className="detail-value"><span className={`status-badge status-${selectedAppointment.status}`}>{getStatusText(selectedAppointment.status)}</span></span></div>
                {selectedAppointment.patient_phone && <div className="detail-row"><span className="detail-label">Hasta Tel:</span> <span className="detail-value">{selectedAppointment.patient_phone}</span></div>}
              </div>
            </div>
            <div className="modal-actions">
              {selectedAppointment.status === 'scheduled' && user.role !== 'patient' && (
                <>
                  <button className="edit-btn" style={{ background: '#1cc88a', flex: 1 }} onClick={() => handleStatusChange(selectedAppointment.id, 'completed')}>Tamamla</button>
                  <button className="delete-btn" style={{ flex: 1 }} onClick={() => handleStatusChange(selectedAppointment.id, 'cancelled')}>İptal Et</button>
                </>
              )}
              <button className="save-btn" style={{ flex: 1 }} onClick={() => setShowDetailModal(false)}>Kapat</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Appointments;